import "./App.css";
import {
  ThemeProvider,
  StyledEngineProvider,
  createTheme,
  adaptV4Theme,
} from "@mui/material/styles";
import { StateProvider } from "./contexts/store";
import MapPage from "./pages/map";

const theme = createTheme(
  adaptV4Theme({
    typography: {
      fontFamily: [
        "Inter",
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(","),
    },
    palette: {
      primary: {
        light: "#CCEFE3",
        main: "#01B075",
        dark: "#017951",
        contrastText: "#fff",
      },
      text: {
        primary: "#1D2023",
        secondary: "#949EA7",
      },
    },
    shape: {
      borderRadius: 8,
    },
    overrides: {
      MuiMenuItem: {
        root: {
          fontWeight: 600,
        },
      },
    },
  })
);

const themeNew = createTheme({
  palette: {
    primary: {
      light: "#CCEFE3",
      main: "#01B075",
      dark: "#017951",
      contrastText: "#fff",
    },
    text: {
      primary: "#1D2023",
      secondary: "#949EA7",
    },
  },
  shape: {
    borderRadius: 8,
  },
  overrides: {
    MuiMenuItem: {
      root: {
        fontWeight: 600,
        // display: "block",
      },
    },
  },
  typography: {
    fontFamily: [
      "Inter",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
});

function App() {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <StateProvider>
          <div className="App">
            <MapPage />
          </div>
        </StateProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
